// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_fr","gallery__header":"c-n_fs","gallery__thumbs":"c-n_ft"};